import type { Project } from '@jarvis/shared';
import { Icon } from '../components/Icon';
import { Resource } from '../components/Resource';
import { toast } from '../components/toast';
import { DemoBadge, Notice, PageHead, Progress } from '../components/ui';
import { fmt } from '../lib/format';
import { usePrefs } from '../lib/prefs';
import { ProjectsLive } from './ProjectsLive';

function DemoProjectCard({ p }: { p: Project }) {
  const done = p.tasks.filter((t) => t.done).length;
  return (
    <article className="card project">
      <div className="chips"><span className={`badge badge-${p.tone}`}>{p.status}</span><DemoBadge /></div>
      <h3>{p.name}</h3>
      <p className="desc">{p.description}</p>
      <div className="usage-row">
        <div className="top"><span className="row-sub">{done} de {p.tasks.length} tarefas</span><span className="mono">{p.progress}%</span></div>
        <Progress value={p.progress} />
      </div>
      <div className="next"><b>Próximo passo</b>{p.next}</div>
      <details className="more">
        <summary><Icon name="check" />Tarefas</summary>
        <ul className="tasks">{p.tasks.map((t) => (
          <li key={t.title}><label>
            <input type="checkbox" defaultChecked={t.done} onChange={() => toast('Alteração de demonstração: não foi salva.', 'info')} />
            <span>{t.title}</span>
          </label></li>))}
        </ul>
      </details>
      <div className="news-meta">
        <Icon name="calendar" /><span>Prazo {fmt.short(p.due)}</span>
        <span>· {p.links.emails} e-mails · {p.links.events} eventos vinculados</span>
      </div>
    </article>
  );
}

export function Projects() {
  const { stateMode } = usePrefs();
  const demo = stateMode === 'demo';
  return (
    <div className="page">
      <PageHead title="Projetos" lead={demo
        ? 'Exemplos fictícios. Marcar tarefas aqui não é salvo.'
        : 'Seus projetos, salvos no banco de dados do Jarvis. Você pode exportar ou apagar tudo em Configurações › Privacidade.'} />
      {demo ? (
        <div className="stack">
          <Notice icon="info">Você está no modo demonstração. Para criar e salvar seus próprios projetos, troque o estado para <a href="#/configuracoes/laboratorio">Dados reais</a>.</Notice>
          <Resource name="projects" skeleton="cards" skeletonCount={4}
            empty={{ icon: 'folder', title: 'Nenhum projeto de demonstração' }}>
            {(items) => <div className="projects">{items.map((p) => <DemoProjectCard key={p.id} p={p} />)}</div>}
          </Resource>
        </div>
      ) : <ProjectsLive />}
    </div>
  );
}
